import React, { Fragment, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useWindowSize from '@hooks/useWindowSize';

import {
	allFilterPages,
	generateSampleListParams,
	sampleListFilterFields
} from '@features/filter/static/filterUtil';
import SampleListTopHeader from '@features/filter/v2/core/Sample/SampleListTopHeader';
import FilterComponent from '@features/filter/v2/FilterComponent';
import SampleRequest from '@features/sampleDevelopment/components/SampleRequest';

import { setCurrentActivePage } from '@store/actions/ActivePageAction';
import {
	clearFilterResponse,
	clearGlobalFilter,
	handleFilter,
	storeItemInGlobalFilter
} from '@store/actions/FilterAction';
import { closeLoader, openLoader } from '@store/actions/LoaderAction';
import { fetchSampleRequestCount } from '@store/actions/SampleAction';

import { fetchDependentFilterList } from '@services/commonService';

import { isPageReachBottom } from '@utils/Util';

const AllSampleRequest = ({ requestFrom }) => {
	const [page, setPage] = useState(0);
	const dispatch = useDispatch();
	const [isShowFilter, setIsShowFilter] = useState(false);
	let filterfields = useSelector((store) => store.filterFieldStore);
	const allSampleList = useSelector((store) => store.filterResponseStore);
	const scrollRef = useRef({});
	const activeTab = filterfields['status'] && filterfields['status'][0]?.value;
	useWindowSize(() => setIsShowFilter(false));

	const setCurrentState = (data) => {
		scrollRef.current = data;
	};
	useEffect(() => {
		setCurrentState(allSampleList);
	}, [allSampleList]);

	useEffect(() => {
		if (activeTab) {
			window.scrollTo(0, 0);
			dispatch(openLoader());
			let queryParams = generateSampleListParams(filterfields, 0);
			Promise.all([
				dispatch(handleFilter('fetchSampleRequest', queryParams, false)),
				dispatch(fetchSampleRequestCount(queryParams))
			]).finally(() => dispatch(closeLoader()));
		}
	}, [filterfields]);

	useEffect(() => {
		if (page !== 0 && activeTab) {
			dispatch(openLoader());
			let queryParams = generateSampleListParams(filterfields, page);
			dispatch(handleFilter('fetchSampleRequest', queryParams, true)).finally(() => {
				dispatch(closeLoader());
			});
			dispatch(fetchSampleRequestCount(queryParams));
		}
	}, [page]);

	useEffect(() => {
		if (isShowFilter) {
			const { ...paramsData } = generateSampleListParams(filterfields);
			dispatch(fetchDependentFilterList({ type: 'SAMPLE_LIST' }, paramsData));
		}
	}, [isShowFilter, filterfields]);

	useEffect(() => {
		if (!filterfields?.status) {
			handleTab('PENDING');
		}
		document.addEventListener('scroll', handleScroll);
		return () => {
			dispatch(clearFilterResponse());
			dispatch(
				setCurrentActivePage({
					id: null,
					type: '',
					pageType: 'DETAILS'
				})
			);
			document.removeEventListener('scroll', handleScroll);
		};
	}, []);

	const handleScroll = () => {
		if (isPageReachBottom()) {
			let { totalElements, currentPage, data } = scrollRef.current;
			if (totalElements !== data?.length) {
				setPage(() => currentPage + 1);
			}
		}
	};
	const onCollspseFilter = () => setIsShowFilter(!isShowFilter);

	const renderAlertMessage = () => {
		if (allSampleList?.data?.length === 0) {
			return (
				<div className="alert alert-secondary text-center">
					<p>No sample request found</p>
				</div>
			);
		}
	};
	const handleTab = (type) => {
		let data = {};
		data = {
			key: type,
			name: 'status',
			value: type,
			type: 'SELECT'
		};
		dispatch(clearGlobalFilter());
		dispatch(storeItemInGlobalFilter(data));
	};

	return (
		<>
			{requestFrom !== 'CRM' && (
				<div className="top-header transparent-filter">
					<div className="page-title-area">
						<h1 className="semibold-16">Sample</h1>
					</div>
					<div className="navigation-tab shadow-nav-4dp">
						<ul>
							<li
								onClick={() => handleTab('PENDING')}
								className={activeTab === 'PENDING' ? 'active' : ''}
							>
								Pending
							</li>
							<li
								onClick={() => handleTab('COMPLETED')}
								className={activeTab === 'COMPLETED' ? 'active' : ''}
							>
								Completed
							</li>
						</ul>
					</div>
					<SampleListTopHeader toggleFilter={onCollspseFilter} />
				</div>
			)}
			<section className="filter-data-container filter-v3-data-container on-sample-request">
				<FilterComponent
					filterPageName={allFilterPages.SAMPLE_LIST}
					fields={sampleListFilterFields}
					showFilter={isShowFilter}
					isDependentFilter={true}
				/>

				<div className="data-table">
					<div className="sample-dashboard-container bg-gray">
						<div className="sample-items-row">
							{allSampleList?.data?.map((item) => {
								return (
									<Fragment key={item.id}>
										<SampleRequest dataItem={item} />
									</Fragment>
								);
							})}
							{renderAlertMessage()}
						</div>
					</div>
				</div>
			</section>
		</>
	);
};

export default AllSampleRequest;
